import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {MessageContainer} from 'shells/message/message-container';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {trackIntegrationEnabled} from '../../tables/helpers';

import {ConnectButton} from '../connect-button';

import styles from './connect.module.css';

type Props = {
    isConnected: boolean;
    setPageAutoAdvance: (pageAutoAdvance: boolean) => void;
    setPageAutoPrevious: (pageAutoPrevious: boolean) => void;
    onSuccess?: () => void;
    connectIntegration: (onStart?: () => void, onSuccess?: () => void) => void;
    errorMessage?: string | null | undefined;
    hideErrorMessage: () => void;
    serviceType: ExternalServiceType;
};

export function Connect(props: Props) {
    const {isConnected, setPageAutoAdvance} = props;

    React.useEffect(() => {
        if (isConnected) {
            setPageAutoAdvance(true);
        }
    }, [isConnected, setPageAutoAdvance]);

    const banners = props.errorMessage ? (
        <div className='mt-32'>
            <MessageContainer>
                <FlashBanner hasBorder={true} type='error' onHidden={props.hideErrorMessage}>
                    {props.errorMessage}
                </FlashBanner>
            </MessageContainer>
        </div>
    ) : null;

    return (
        <>
            {banners}
            <OnboardingBody title='Sign in to connect your meetings'>
                <div className={styles['connect-button-container']}>
                    <ConnectButton
                        isConnected={props.isConnected}
                        onConnectClick={() => {
                            props.connectIntegration(
                                () => {
                                    props.setPageAutoAdvance(false);
                                    props.setPageAutoPrevious(false);
                                },
                                () => {
                                    trackIntegrationEnabled(props.serviceType);
                                    props.setPageAutoAdvance(true);
                                    if (props.onSuccess) {
                                        props.onSuccess();
                                    }
                                }
                            );
                        }}
                        serviceType={props.serviceType}
                    />
                </div>
            </OnboardingBody>
        </>
    );
}
